import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

export interface UploadState {
  numberOfRevenueItemsToUpload: number;
  numberOfRevenueItemsUploaded: number;
  numberOfOpportunityItemsToUpload: number;
  numberOfOpportunityItemsUploaded: number;
}

const initialState: UploadState = {
  numberOfRevenueItemsToUpload: 0,
  numberOfRevenueItemsUploaded: 0,
  numberOfOpportunityItemsToUpload: 0,
  numberOfOpportunityItemsUploaded: 0
};

const uploadSlice = createSlice({
  name: 'uploads',
  initialState,
  reducers: {
    resetSlice: (state) => (state = initialState),
    onNumberOfRevenueItemsToUploadChanged: (
      state,
      { payload }: { payload: number }
    ) => {
      state.numberOfRevenueItemsToUpload = payload;
    },
    onNumberOfRevenueItemsUploadedChanged: (
      state,
      { payload }: { payload: number }
    ) => {
      state.numberOfRevenueItemsUploaded = payload;
    },
    onNumberOfOpportunityItemsToUploadChanged: (
      state,
      { payload }: { payload: number }
    ) => {
      state.numberOfOpportunityItemsToUpload = payload;
    },
    onNumberOfOpportunityItemsUploadedChanged: (
      state,
      { payload }: { payload: number }
    ) => {
      state.numberOfOpportunityItemsUploaded = payload;
    }
  }
});

export const uploadStateSelector = createSelector(
  (state: RootState) => state.upload,
  (state) => state
);

export const uploadRevenuePercentageSelector = createSelector(
  (state: RootState) => state.upload,
  (state) =>
    (state.numberOfRevenueItemsUploaded * 100) /
    state.numberOfRevenueItemsToUpload
);

export const uploadOpportunityPercentageSelector = createSelector(
  (state: RootState) => state.upload,
  (state) =>
    (state.numberOfOpportunityItemsUploaded * 100) /
    state.numberOfOpportunityItemsToUpload
);

export const {
  resetSlice,
  onNumberOfRevenueItemsToUploadChanged,
  onNumberOfRevenueItemsUploadedChanged,
  onNumberOfOpportunityItemsToUploadChanged,
  onNumberOfOpportunityItemsUploadedChanged
} = uploadSlice.actions;

export default uploadSlice.reducer;
